import {
  BASE_URL_WEB_APP_DEV,
  BASE_URL_WEB_APP_PROD,
  GO_LINK_ADJ_T,
} from '@/app/main/split-bills/constants';
import {isProduction} from '@/utils/environment';

import {buildAdjustLink} from './buildAdjustLink';

const COMMON_ROOT_ROUTE = 'SPLITS';

export const buildSplitInviteLink = (splitId: string): string => {
  const path = `${COMMON_ROOT_ROUTE}/${splitId}`;

  const baseUrl = isProduction ? BASE_URL_WEB_APP_PROD : BASE_URL_WEB_APP_DEV;

  const fallbackParams = new URLSearchParams({splitId});
  const fallbackUrl = `${baseUrl}/splits?${fallbackParams.toString()}`;

  return buildAdjustLink({
    path,
    fallbackUrl,
    adjT: GO_LINK_ADJ_T,
  });
};
